import React from 'react';
import PropTypes from 'prop-types';
import * as S from './index.styles';
import { Icon } from '../../Atoms/Icon';
import appleStoreIcon from '../../Assets/apple_store_icon.svg';
import googleStoreIcon from '../../Assets/google_play_icon.svg';

export const HelperFooter = ({
    title,
    description,
    app,
    email,
    phone,
    whatsapp,
    hideFooterDescription,
    url,
}) => {
    return (
        <S.Container>
            <S.Header>
                <S.HeaderTitle>
                    <S.Title large weight="bold">
                        {title}
                    </S.Title>
                    <S.Description href={url} target="_blank" large weight="bold">
                        {description}
                    </S.Description>
                </S.HeaderTitle>
                <S.AppStore>
                    <S.AppStoreTitle large>{app}</S.AppStoreTitle>
                    <S.AppStoreImages>
                        <img src={appleStoreIcon} alt="apple store" />
                        <img src={googleStoreIcon} alt="google store" />
                    </S.AppStoreImages>
                </S.AppStore>
            </S.Header>
            {!hideFooterDescription && (
                <S.Footer>
                    <S.FooterEmail large weight="bold">
                        <Icon icon={['far', 'envelope']} size="small" />
                        {email}
                    </S.FooterEmail>
                    <S.FooterPhone large weight="bold">
                        <Icon icon="phone" />
                        {phone}
                    </S.FooterPhone>
                    <S.FooterWhatsApp large weight="bold">
                        <Icon icon={['fab', 'whatsapp']} />
                        {whatsapp}
                    </S.FooterWhatsApp>
                </S.Footer>
            )}
        </S.Container>
    );
};

HelperFooter.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    app: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    whatsapp: PropTypes.string,
    hideFooterDescription: PropTypes.bool,
    url: PropTypes.string,
};

HelperFooter.defaultProps = {
    title: 'Precisa de ajuda?',
    description: 'Fale com a Terra Investimentos',
    app: 'Baixe nosso app',
    email: 'investidor@terrainvestimentos.com.br',
    phone: '(11) 2050-2803',
    whatsapp: '(11) 9 3759-5880 (WhatsApp)',
    hideFooterDescription: false,
    url: 'https://www.terrainvestimentos.com.br',
};
